import axios from 'axios'
import { errorAlert } from "./alert";
import { errorAlertApp } from "./alert_app";
import pinia from '../stores/index'
import { useChatStore } from '../stores/chat';
const chat = useChatStore(pinia);
import { useBatchStore } from '../stores/batch';
const batch = useBatchStore(pinia);

const axios_instance = axios.create();
axios_instance.interceptors.request.use(config => {
	config.headers = {
		'X-CSRFToken' : <string>(document.getElementsByName('csrf_token').length == 0 ? '' : (!document.getElementsByName('csrf_token')[0].getAttribute('content') ? "" :  document.getElementsByName('csrf_token')[0].getAttribute('content'))),
		'Tokiwa-Api-Key': <string>(document.getElementsByName('tokiwa_api_key').length == 0 ? '' : (!document.getElementsByName('tokiwa_api_key')[0].getAttribute('content') ? "" :  document.getElementsByName('tokiwa_api_key')[0].getAttribute('content'))),
	}
	return config
})

axios_instance.interceptors.response.use(
	(response) => {
		//処理が余りにも遅い場合は考える
		//スマホアプリの場合は実行しない
		if (!location.pathname.startsWith('/spapp/')) {
			chat.fetchUnreadCount();
			batch.fetchUnread();
		}
		return Promise.resolve(response);
	},
	(error) => {
		// 何らかの処理が可能
		if (typeof error.response !== 'undefined') {
			if (error.response.status == 401) {
			} else if (error.response.status == 403) {
			}
		}
		if (axios.isCancel(error) != true) {
			if (!location.pathname.startsWith('/spapp/')) {
				errorAlert(error);
			} else {
				errorAlertApp(error);
			}
		}
		return Promise.reject(error);
	}
)

export default axios_instance;
